import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

export interface IContentProps {
  title: any;
  description: any;
}

export function ConfirmModal(props: IContentProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <Dialog
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => dispatch({ type: "MODAL_CANCEL" })}
        >
          {t("cancel")}
        </Button>
        <Button
          color={
            props.title === t("remove") || props.title === t("reset")
              ? "error"
              : "success"
          }
          variant="contained"
          onClick={() => dispatch({ type: "MODAL_CONFIRM" })}
          autoFocus
        >
          {props.title === t("remove") ? t("remove") : t("confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
